<template>
    <div>
        <input type="hidden" name="id" :value="filter_item_for_reserve.hash">
        <template v-if="!is_pre_order_cancel_end && false">
        <div class="coupon" v-if="user_data">
            <g-loading v-show="is_loading.coupon" :full_view="false"></g-loading>
            <div class="coupon-box" :class="{ selected: selected_coupon !== null }" @click="openCouponList" v-show="!is_loading.coupon">
                <span class="c-icon is-coupon is-current-color"></span>
                <div class="text-container">
                    <div v-show="selected_coupon" class="selected-text">選択済み</div>
                    <div class="u-text-ellipsis">{{ getSelectedCouponName }}</div>
                </div>
                <div class="arrow-container" v-show="!in_cart">
                    <span class="c-icon" :class="{ 'open': is_open, 'is-stroke-right': !invalid_coupon }"></span>
                </div>
                <input type="hidden" name="coupon_code" :value="getSelectedCouponCode">
            </div>
            <div v-if="in_cart" class="warning">
                この商品は予約済みです。<br>クーポンを変更したい場合は、一旦予約をキャンセルしてください。
            </div>
            <div v-show="is_open">
                <div class="price-radio-box justify-center no-top-border">
                    <input class="custom-radio" type="radio" id="coupon_unselected" v-model="selected_coupon" :value="null" />
                    <label for="coupon_unselected">クーポン解除</label>
                </div>
                <div v-for="user_coupon in this.user_coupon_list" class="price-radio-box">
                    <input class="custom-radio" type="radio" :id="user_coupon.activate_code" v-model="selected_coupon" :value="user_coupon" />
                    <label :for="user_coupon.activate_code">
                        <div class="coupon-title u-mt-1">{{ user_coupon.COUPON_NAME }}</div>
                        <p v-if="user_coupon.FOR_ALL_ITEMS" class="coupon-detail">種別：{{ user_coupon.discount_value }}OFF</p>
                        <p v-else class="coupon-detail">種別：{{ getDiscountValue(user_coupon.DISCOUNT_PRICE) }}</p>
                        <p class="coupon-detail">クーポンコード：{{ user_coupon.activate_code }}</p>
                        <p class="coupon-detail" v-show="user_coupon.dsp_usage_end_date">有効期限：{{ user_coupon.dsp_usage_end_date }}まで有効</p>
                    </label>
                </div>
            </div>
        </div>
        <div class="login-button" v-else v-show="!is_loading.coupon">
            <a class="c-round-btn is-full-width" @click="redirectLogin">ログインしてクーポンを見る</a>
        </div>
        </template>
        <div v-if="selected_coupon" class="c-thumbnail-list__price c-black u-mb10-pc u-mb5-sp">
            <p>
                <span class="c-price-and-tax is-big" data-cy="item_detail_reserve-details_coupon-price">
                    <span class="c-price_value">￥{{ item_detail.current_tax_price }}</span><span class="c-price_tax">（税込）</span>
                </span>
            </p>
        </div>
        <div v-if="!is_loading.price">
            <p class="price-title u-mb-3">週プレ プラス！会員価格</p>
            <span class="c-price-and-tax is-big is-orange">
                <span class="c-price_value">￥{{ item_detail.current_tax_plus_price }}</span>
                <span class="c-price_tax">（税込）</span>
                <span  class="c-label is-orange">{{ item_detail.plus_discount_string }}OFF</span>
            </span>
        </div>
        <div class="prerelease-text">{{ getDspStartDateFormat }}</div>
        <template v-if="is_pre_ordered">
            <button class="c-round-btn submit-button is-disabled" disabled="true">予約済み</button>
            <div v-if="!is_pre_order_cancel_end" class="cancel-button" style="text-align: center;">
                <a style="display: inline-block; color:blue; text-decoration: underline;" href="javascript:void(0)"
                    v-on:click="openCancelReserveModal()">キャンセルはこちら</a>
            </div>
        </template>
        <template v-else-if="is_pre_order_end">
            <button class="c-round-btn submit-button is-disabled" disabled="true">予約受付は終了しました</button>
        </template>
        <template v-else-if="is_cant_pre_order">
            <div class="error-msg-area">
                <p>本誌定期購読の冊数が残っているため予約できません</p>
            </div>
            <button class="c-round-btn submit-button is-disabled" disabled="true">定期購読中</button>
        </template>
        <template v-else>
            <button class="c-round-btn submit-button is-positive" type="submit">予約をする</button>
        </template>
        <div class="about-pre-order">予約については<a :href="reserveQuestionPath" class="c-link-text">こちら</a>からご確認ください。</div>
        <template v-if="is_pre_ordered">
            <a class="c-round-btn is-positive is-transparent submit-button ordered-list"
                :href="route(route_list, 'site.item.pre_order.ordered')">予約済商品一覧へ</a>
        </template>
        <div class="about-container">
            <template v-if="!is_pre_order_end">
                <div v-if="item.has_plus_special_discount && item.plus_discount_message_for_reserve"
                    class="about-plus-member" v-html="item.plus_discount_message_for_reserve"></div>
                <div v-else class="about-plus-member">プラス！会員の方は、<span class="discount">10～30%の割引価格</span>でご購入いただけます。<br></div>
                <ul class="c-thumbnail-list__pre_order browser-default">
                    <li>発売日までにプラス！を退会してしまうと会員割引の適用がされません。</li>
                </ul>
            </template>
        </div>
    </div>
</template>

<script>
import routeMixin from '../../../mixins/route.js';
import moment from 'moment';
import axios from 'axios';

export default {
    props: {
        route_list: Object,
        item_hash: String,
        is_pre_ordered: false,
        is_pre_order_end: false,
        is_pre_order_cancel_end: false,
        is_cant_pre_order: false,
        cancel_subscription_info: Object,
        price_for_plus: Number,
        item: Object,
        filter_item_for_reserve: Object,
        plus_discount_rate: Number,
        is_complete: Number,
        in_cart: false,
        cart: Object,
        ordered_coupon_name: null,
    },
    data() {
        return {
            reserveQuestionPath: "/post/yoyaku",
            user_data: null,
            is_loading: {
                coupon: true,
                price: true,
            },
            selected_coupon: null,
            user_coupon_list: null,
            coupon_list: [],
            is_open: false,
            item_detail: {
                price: null,
                is_campaign: null,
                sale_end_date: null,
                discount_string: "",
                plus_discount_string: "",
                total_discount_string: "",
            },
            invalid_coupon: false,
        };
    },
    mixins: [routeMixin],
    methods: {
        openCancelReserveModal: function () {
            // カスタムイベントを発火してモーダルを開く（production対応）
            window.dispatchEvent(new CustomEvent('open-cancel-reserve-modal'));
        },
        openCouponList: function () {
            if(this.in_cart || this.invalid_coupon) {
                return;
            }
            if (this.user_data && !this.user_coupon_list) {
                this.initCouponList();
                return;
            }
            this.is_open = !this.is_open;
        },
        initCouponList: function (from_mount = false) {
            let params = {
                'params': {
                    hash: this.item_hash,
                    exclude_cart_coupon: true,
                    isPreOrder : true,
                }
            }
            if (!from_mount) {
                this.is_open = false;
            } else {
                params = {
                    'params': {
                        hash: this.item_hash,
                        isPreOrder: true
                    }
                }
            }
            let url = this.route(this.route_list, 'site.api.user.myCouponList');
            axios.get(url, params).then(res => {
                if (!from_mount) {
                    this.user_coupon_list = res.data.data.user_coupon_list;
                    this.is_open = true;
                } else {
                    this.coupon_list = res.data.data.user_coupon_list;
                    if(this.coupon_list.length === 0) {
                        this.invalid_coupon = true;
                    }
                }
            }).catch(error => {
                if (!from_mount) {
                    this.user_coupon_list = [];
                    this.is_open = false;
                } else {
                    this.coupon_list = [];
                }
            });
        },
        setItemPrice: async function () {
            this.is_loading.price = true;
            let url = this.route(this.route_list, 'site.api.item.detail', {
                'hash'   : this.item_hash,
                'coupon' : this.selected_coupon ? this.selected_coupon.activate_code : '',
                'isPreOrder' : true,
            });
            await axios.get(url, {
                params: {
                }
            }).then(res => {
                this.item_detail = res.data.data
                this.is_loading.price = false;
            }).catch(error => {
                this.is_loading.price = false;
            });
        },
        setUserData: function () {
            this.is_loading.coupon = true;
            let url = this.route(this.route_list, 'site.api.user.plusInfo');
            axios.get(url, {
                params: {
                }
            }).then(res => {
                this.user_data = res.data.data;
                this.is_loading.coupon = false;
                this.setItemPrice();
            }).catch(error => {
                this.is_loading.coupon = false;
                this.setItemPrice();
            });
        },
        setDiscountRate: function () {
            this.is_loading.coupon = true;
            let url = this.route(this.route_list, 'site.api.plus.subscription.discountRateMinMax');
            axios.get(url, {
                params: {
                }
            }).then(res => {
                this.discount_rate = res.data.data
            }).catch(error => {
            });
        },
        getDiscountValue: function (discount) {
            let price = this.item_detail.current_base_price - discount;
            price = price.toLocaleString("ja-JP", { style: "currency", currency: "JPY" });
            return price + ' OFF';
        },
        redirectLogin: function () {
            let current_url = window.location.pathname;
            let url = this.route(this.route_list, 'site.signin', { 'backUrl': current_url });
            window.location.href = url;
        },
    },
    created() {
        this.setUserData();
        this.setDiscountRate();
    },
    mounted() {
        this.initCouponList(true);
    },
    computed: {
        getDspStartDateFormat: function () {
            return this.filter_item_for_reserve.disp_start_date ? moment(this.filter_item_for_reserve.disp_start_date).format('Y年M月D日HH:mm発売予定です。') : '';
        },
        getSelectedCouponName: function () {
            if (this.is_pre_ordered && this.ordered_coupon_name) {
                return this.ordered_coupon_name
            }
            if (this.invalid_coupon) {
                return '使えるクーポンはありません';
            }
            if (this.in_cart && this.coupon_list.length > 0) {
                let coupon_code = this.cart[this.item_hash].coupon_code;
                if(!coupon_code) {
                    return '使えるクーポンがあります';
                }
                let selected_name = '使えるクーポンがあります';
                this.coupon_list.forEach(coupon => {
                    if(coupon.activate_code === coupon_code) {
                        selected_name = coupon.COUPON_NAME;
                    }
                });
                return selected_name
            }
            return this.selected_coupon ? this.selected_coupon.COUPON_NAME : '使えるクーポンがあります';
        },
        getSelectedCouponCode: function () {
            return this.selected_coupon ? this.selected_coupon.activate_code : '';
        },
    },
    watch:
    {
        selected_coupon: function (new_value) {
            this.is_open = false;
            this.setItemPrice();
            let target = document.querySelectorAll('.js-line-through');
            if (target.length > 0) {
                if (new_value) {
                    if (!target[0].classList.contains('c-line-through')) {
                        target[0].classList.add('c-line-through');
                    }
                } else {
                    target[0].classList.remove('c-line-through');
                }
            }
        },
        coupon_list: function() {
            this.getSelectedCouponName;
        }
    },
}
</script>

<style lang="scss" scoped>
.coupon-box {
    --icon-size: 24px;
    height: 56px;
    padding: 8px 15px;
    border: 1px solid var(--gj-border-color);
    font-size: 14px;
    font-weight: 600;
    line-height: 130%;
    color: var(--gj-color-light-grey);
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 8px;
    cursor: pointer;

    .text-container {
        width: calc(100% - var(--icon-size) * 2 - 16px);

        .selected-text {
            color: var(--gj-color-blue);
        }
    }

    .c-icon.is-stroke-right {
        transform: rotate(90deg);
        transition: transform 0.2s;

        &.open {
            transform: rotate(-90deg);
        }
    }

    &.selected {
        color: var(--gj-text-color);

        .c-icon.is-coupon {
            color: var(--gj-color-blue);
        }
    }
}

.price-radio-box {
    padding: 16px 15px;
    border: 1px solid var(--gj-border-color);
    display: flex;
    gap: 8px;

    &:not(:first-child) {
        border-top: none;
    }

    &.no-top-border {
        border-top: none;
    }

    .custom-radio {
        flex: 0 0 auto;
        appearance: none;
        border: 1px solid #b7c5cb;
        border-radius: 50%;
        width: 24px;
        height: 24px;
        position: relative;
        opacity: 1;
        cursor: pointer;
        pointer-events: unset;

        &:checked {
            border-color: var(--gj-color-blue);

            &::after {
                content: "";
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                width: 18px;
                height: 18px;
                border-radius: 50%;
                background-color: var(--gj-color-blue);
            }
        }
    }
    label {
        display: flex;
        flex-direction: column;
        justify-content: center;
        line-height: 130%;
        gap: 2px;
        color: var(--gj-text-color);
        font-size: 14px;
        font-weight: 600;
        line-height: 130%;
        flex: 1 1 auto;

        .coupon-title {
            font-size: 14px;
            font-weight: 600;
            line-height: 130%;
            margin-bottom: 8px;
        }
        .coupon-detail {
            color: var(--gj-text-color-light);
            font-size: 11px;
            font-weight: 300;
            line-height: 130%;

            &.alert {
                font-size: 10px;
                color: var(--gj-color-red);
            }
        }
        .discount-rate {
            margin-top: 12px;
            display: flex;
            flex-direction: column;
            gap: 4px;
        }
        .now-sale {
            color: var(--gj-color-pink);
            font-size: 11px;
            font-weight: 600;
            line-height: 130%;
        }
    }
}

.price {
    display: flex;
    align-items: center;
}

.price-title {
    color: var(--gj-text-color);
    font-size: 14px;
    font-weight: 600;
    line-height: 130%;
}

.sale-label {
    display: flex;
    align-items: center;
    gap: 8px;
}

.check-icon {
    --icon-size: 14px;
    color: var(--gj-color-orange);
}

.login-button-container {
    border: 1px solid var(--gj-border-color);
    border-top: none;
    padding: 16px 15px;
}

.buttons {
    margin-top: 24px;
    gap: 8px;

    @media (min-width: 768px) {
        gap: 16px;
    }
}
.coupon-activate-wrapper {
    margin: 24px 0;
}
.warning {
    margin-top: 10px;
    font-size: 15px;
    font-weight: 600;
    line-height: 130%;
    color: var(--gj-color-red);
}

.login-button {
    margin-bottom: 24px;
}

.m-bottom-20 {
    margin-bottom: 20px;
}

.about-pre-order {
    text-align: center;
    font-size: 12px;
    font-weight: 300;
    margin-top: 15px;
    margin-bottom: 15px;
}

.ordered-list {
    margin-top:30px;
}

.cancel-button {
    text-align: center;
    font-size: 12px;
    font-weight: 300;
    margin-top: 15px;
    margin-bottom: 15px;
}

:where(button, a).c-round-btn.submit-button {
    width: 295px;
    display: block;
    margin-inline: auto;
    @media (min-width: 768px) {
        width: 100%;
    }
}

.about-container {
    margin-inline: 20px;
    margin-top:40px;
    @media (min-width: 768px) {
        margin-inline: 0px;
    }
}

.about-plus-member {
    border: 2px solid #FF873C;
    padding: 12px 16px;
    font-size: 14px;
    font-weight: 600;
    line-height: 18.2px;
    color: var(--gj-text-color);
    margin-bottom: 8px;

    .discount {
        color: #FF873C;
    }
}
</style>
